import React from 'react';
import { Typography } from '@scale/scaleui';
import TemplatesOverview from './TemplatesOverview';

const TemplatesLibraryPage = () => {
  return (
    <div className="p-8 flex flex-col gap-4 h-full">
      <div className="flex flex-row justify-between w-full gap-5 items-center">
        <Typography.H4>Template Library</Typography.H4>
      </div>
      <TemplatesOverview />
    </div>
  );
};

export default TemplatesLibraryPage;
